/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

export enum ArticleTicketType {
    Access = "access",
    AccessExtra = "access_extra",
    Accessories = "accessories",
    Discount = "discount",
    DiscountPercent = "discount_percent",
    DriftPark = "drift_park",
    Event = "event",
    Gift = "gift",
    Karting = "karting",
    Product = "product",
    Race = "race",
    Voucher = "voucher",
}
